import styles from './styles.module.scss';

const CustomTattoo = () => {
    return (
        <div className={styles.customTattooContainer}>
            <h1>Custom Tattoo</h1>
        </div>
    );
}

export default CustomTattoo;
